import script from "./file-upload.vue?vue&type=script&setup=true&lang=ts"
export * from "./file-upload.vue?vue&type=script&setup=true&lang=ts"

import "./file-upload.vue?vue&type=style&index=0&id=25772f88&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25772f88"]])

export default __exports__